export default __webpack_public_path__ + "static/media/a3.cf01ba01.jpg";